import { useEffect, useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import map from 'lodash/map';
import { useHistory } from 'react-router-dom';
import { useUserContext } from '@fff-web/fff-utilities';
import usePagination from '../hooks/usePagination';
import { getAllInvoicesByUserId } from '../services/api/account';
import LoadingLogo from '../shared-components/LoadingLogo/LoadingLogo';
import PageContainer from '../shared-components/PageContainer/PageContainer';
import Pagination from '../shared-components/Pagination/Pagination';
import { scrollToTopGradually } from '../shared-components/ScrollToTopButton/ScrollToTopButton';
import Invoice from './Invoice';
import * as styles from './InvoiceHistory.module.css';

const INVOICES_PER_PAGE = 10;
const getTotalPages = (totalInvoices) => Math.ceil(totalInvoices / INVOICES_PER_PAGE);

const InvoiceHistory = () => {
  const { userInfo } = useUserContext();
  const userId = userInfo?.user?.userId;
  const [loading, setLoading] = useState(true);
  const [invoices, setInvoices] = useState({
    items: [],
    totalPages: 0,
  });
  const { limit, offset, currentPage, onClickPage } = usePagination({
    INVOICES_PER_PAGE,
  });
  const { items, totalPages } = invoices;
  const { myAccountOrderHistory: myAccountOrderHistoryFF } = useFlags();
  const history = useHistory();
  const slicedInvoices = items.slice(offset, offset + limit);

  const handleClickBack = () => history.push('/my-account/orders');

  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        setLoading(true);
        scrollToTopGradually();

        const allInvoicesRes = await getAllInvoicesByUserId(userId);

        setInvoices({
          items: allInvoicesRes,
          totalPages: getTotalPages(allInvoicesRes.length),
        });
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    if (userId) {
      fetchInvoices();
    }
  }, [userId]);

  if (loading) return <LoadingLogo />;

  return (
    <PageContainer>
      <div className={styles.header}>
        {myAccountOrderHistoryFF && (
          <button type="button" onClick={handleClickBack}>
            <i className="far fa-chevron-left" />
            Back to Orders
          </button>
        )}
        <h1>{myAccountOrderHistoryFF ? 'Invoices' : 'Invoice History'}</h1>
      </div>
      <div className={styles.invoices}>
        {map(slicedInvoices, (invoice, index) => {
          const { invoiceNumber } = invoice;
          return <Invoice key={invoiceNumber} tabIndex={index} invoice={invoice} />;
        })}
        {totalPages > 1 && (
          <Pagination
            pageCount={totalPages}
            currentPage={currentPage}
            containerClassName={styles.paginationContainer}
            onPageChange={onClickPage}
          />
        )}
      </div>
    </PageContainer>
  );
};

export default InvoiceHistory;
